import React from 'react';
import s from './style.module.css';
import * as Icon from 'react-feather';


class Checkbox extends React.Component {
	render(props) {
		return (
			<span className={s.wrapper}>
				<input type="checkbox" checked={this.props.checked} value={this.props.checked} name={this.props.name} onClick={this.props.onClick} readOnly className={s.checkbox}  required={this.props.required}/>
				<span className={`${typeof this.props.error !== 'undefined' ? s.mError : ""} ${s.checkboxFaux} `}>
					{this.props.checked &&
						<Icon.Check className={s.icon} color="#fff" />
					}
				</span>
				<label className={`${typeof this.props.error !== 'undefined' ? s.mActive : ""} ${s.errorText} `}>{typeof this.props.error !== 'undefined' ? this.props.error : ""}</label>
			</span>
		)
	}
}

export default Checkbox;
